module.exports = __webpack_public_path__ + "static/img/pos_im.518f2e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/pos_im.png
// module id = MYsH
// module chunks = 8